import React, { useState } from 'react';
import { Button, Input } from 'antd';
import { useHistory } from 'react-router-dom';

import './ReceptionComment.less'; // Create this file for the CSS
import { usePackagingFlow } from '../../context/PackagingFlowContext';
import { createPackagingFlow } from '../../queries/api/packaging-flow';
import { ShipmentSuccess } from '../shipment';

const { TextArea } = Input;

const ReceptionComment: React.FC = () => {
    const [comment, setComment] = useState<string>(); // Initialize with existing comment if available
    const { packageFlow, setPackageFlow } = usePackagingFlow();
    const [isSuccess, setIsSuccess] = useState<boolean>(false); // State to track success status

    const history = useHistory();

    const handleSave = async () => {
        if (packageFlow) {
            const updatedPayload = {
                ...packageFlow,
                comment,
            };
            setPackageFlow(updatedPayload);
            try {
                const response = await createPackagingFlow(updatedPayload);
                if (response) {
                    setIsSuccess(true); // Set success status to true
                }
            } catch (error) {
                console.error('Error posting shipment data:', error);
            }
        }
    };

    if (isSuccess) {
        return <ShipmentSuccess />;
    }

    return (
        <div className="reception-container">
            <h2 className="reception-title">Souhaitez-vous ajouter des réserves à cette réception ?</h2>
            <div className="reception-comment">
                <label htmlFor="comment">Commentaire</label>
                <TextArea
                    id="comment"
                    placeholder="Remarque sur un support, ..."
                    rows={4}
                    className="comment-textarea"
                    value={comment}
                    onChange={(e) => setComment(e.target.value)} // Update the comment state
                />
            </div>

            <div className="bottom">
                <footer>
                    <div className="action-buttons">
                        <Button onClick={() => history.goBack()}>Annuler</Button>
                        <Button type="primary" onClick={handleSave}>
                            Valider la reception
                        </Button>
                    </div>
                </footer>
            </div>
        </div>
    );
};

export default ReceptionComment;
